import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, setUserId, setUserProperties } from 'firebase/analytics';

import { useAuthUserStore } from '@/app/stores/user';
import { parseUserAgent } from '@/shared/lib/user-agent';

let analyticsInitialized = false;

export function useAnalytics(eventName: string, params?: any) {
  if (import.meta.env.DEV || !import.meta.env.VITE_APP_ANALYTICS_CONFIG) return;

  if (!analyticsInitialized) {
    const firebaseConfig = JSON.parse(import.meta.env.VITE_APP_ANALYTICS_CONFIG);
    const app = initializeApp(firebaseConfig);
    const analytics = getAnalytics(app);
    const { name, version, platform } = parseUserAgent();
    setUserProperties(analytics, {
      app_version: import.meta.env.VITE_APP_VERSION,
      device_model: 'mobile',
      browser_name: name,
      browser_version: version,
      screen_resolution: `${window.screen.width}x${window.screen.height}`,
      operating_system: platform,
    });

    const { userId } = useAuthUserStore();
    if (userId) setUserId(analytics, userId.toString());

    analyticsInitialized = true;
  }

  const parameters = {
    ...params,
    lang: localStorage.getItem('lang'),
    app_version: import.meta.env.VITE_APP_VERSION,
  };
  logEvent(getAnalytics(), eventName, parameters);
}
